import loadable from '@loadable/component';

import type { Portfolio } from '@/hooks/usePortfolio';

import { usePortfolioDiversification } from './hooks';

const PopulatedState = loadable(() => import('./components/PopulatedState'), {
  resolveComponent: (c) => c.PopulatedState,
});

const EmptyState = loadable(() => import('./components/EmptyState'), {
  resolveComponent: (c) => c.EmptyState,
});

const ErrorState = loadable(() => import('./components/ErrorState'), {
  resolveComponent: (c) => c.ErrorState,
});

const LoadingState = loadable(() => import('./components/LoadingState'), {
  resolveComponent: (c) => c.LoadingState,
});

interface Props {
  portfolio: Portfolio;
}

export const DiversificationAcrossIndustries = ({ portfolio }: Props) => {
  const { data, isLoading, isError } = usePortfolioDiversification(
    portfolio.id
  );

  const holdingsWithAllocation = portfolio.holdings.filter(
    (n) => n.analysis.allocation > 0
  );

  if (isLoading) {
    return <LoadingState />;
  }

  if (isError) {
    return <ErrorState />;
  }

  if (
    typeof data?.diversification?.sectors === 'undefined' ||
    holdingsWithAllocation.length === 0
  ) {
    return <EmptyState />;
  }

  return (
    <PopulatedState
      diversification={data.diversification}
      holdingsCount={holdingsWithAllocation.length}
    />
  );
};
